import { NumericFormat } from 'react-number-format';
import FieldValidationError from './FieldValidationError';

const InputDecimal = (props) => {
    const { className, ...rest } = props; // Desestruturando className do restante das props

    return (
        <>
            {/* O placeholder vem ANTES do spread para poder ser trocado por quem usa o
                componente. Depois dele, o '0,00' vencia sempre, e um campo opcional não
                conseguia dizer na própria caixa que pode ficar vazio. */}
            <NumericFormat className={"form-control input-default " + className} placeholder='0,00' {...rest}
                decimalScale={2} decimalSeparator=","/>
            <FieldValidationError error={props.error}/>
        </>
    );
}

export default InputDecimal;